function createHTML(img) {
	const div = document.createElement('div')
	div.classList.add('gif-player')
	addStyles(div, {
		position: 'relative',
	})
	img.classList.add('gif-player-img')
	addStyles(img, {
		position: 'absolute',
		'z-index': 1,
		opacity: 0,
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
	})
	img.parentNode.insertBefore(div, img)
	div.appendChild(img)
	const canvas = document.createElement('canvas')
	canvas.classList.add('gif-player-canvas')
	addStyles(canvas, {
		position: 'absolute',
		'z-index': 0,
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
	})
	div.appendChild(canvas)
	return { div, img, canvas }
}

function addStyles(elem, styles) {
	Object.keys(styles).forEach((style) => {
		elem.style[style] = styles[style]
	})
}

export class GifPlayer {
	constructor(img, options) {
		options = options || {}
		if (!img) {
			console.error('[GIF PLAYER] element not available', img)
			return false
		}
		if (img.tagName !== 'IMG') {
			console.error('[GIF PLAYER] element must be of type <img>', img)
			return false
		}

		const html = createHTML(img)
		this._container = html.div
		this._gif = html.img
		this._canvas = html.canvas
		this.isPlaying = !!options.play
		this.isReady = false

		if (options.resize !== false) {
			this._watchForResize()
		}

		if (this._gif.complete) {
			this._copyToCanvas()
		} else {
			this._gif.addEventListener('load', () => {
				this._copyToCanvas()
			})
		}
	}

	_copyToCanvas() {
		const rect = this._gif.getBoundingClientRect()
		const clientWidth = Math.ceil(rect.width)
		const clientHeight = Math.ceil(rect.height)

		const sizes = {
			width: `${rect.width}px`,
			height: `${rect.height}px`,
		}

		Object.assign(this._container.style, sizes)
		Object.assign(this._canvas.style, sizes)

		this._canvas.setAttribute('width', clientWidth.toString())
		this._canvas.setAttribute('height', clientHeight.toString())

		const ctx = this._canvas.getContext('2d')
		ctx.drawImage(this._gif, 0, 0, clientWidth, clientHeight)

		this.isReady = false

		this._update()
	}

	_watchForResize() {
		this._observer = new ResizeObserver(() => {
			window.requestAnimationFrame(() => {
				this._copyToCanvas()
			})
		})
		this._observer.observe(this._gif)
	}

	_update() {
		this._gif.style.opacity = this.isPlaying ? 1 : 0
	}

	start() {
		this.isPlaying = true
		this._update()
	}

	stop() {
		this.isPlaying = false
		this._update()
	}

	toggle() {
		this.isPlaying = !this.isPlaying
		this._update()
	}
}
